"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addBankingData = addBankingData;
exports.addPhoneNumber = addPhoneNumber;
exports.default = void 0;
exports.deletePhoneNumber = deletePhoneNumber;
exports.editPhoneNumbers = editPhoneNumbers;
exports.getBankDetails = getBankDetails;
exports.getBusinessPartner = getBusinessPartner;
exports.getMyData = getMyData;
exports.getPersonalData = getPersonalData;
exports.getPhoneNumbers = getPhoneNumbers;
exports.getPhonenIdFromPhoneObject = getPhonenIdFromPhoneObject;
exports.getTaxVatNumbers = getTaxVatNumbers;
exports.refreshToken = void 0;
exports.saveMyData = saveMyData;
exports.validatePhoneNumber = exports.saveTaxVatNumber = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _RestHelper = _interopRequireWildcard(require("../utils/RestHelper"));
var _CacheHandler = _interopRequireDefault(require("../../utils/CacheHandler"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var validatePhoneNumber = exports.validatePhoneNumber = function validatePhoneNumber(phoneNumber) {
  var pattern = new RegExp('^(\\+[1-9]|[0-9])[\\d\\s\\-]+$');
  if (!pattern.test(phoneNumber)) {
    var data = {
      countryCode: null,
      formattedNumber: null,
      nationalNumber: null,
      number: phoneNumber,
      region: null,
      type: null,
      valid: false
    };
    return Promise.resolve({
      data: data
    });
  }
  return _RestHelper.default.post("".concat(_RestHelper.default.getBaseUrl(_RestHelper.MWDomains.cscCustomer), "/cscn-customer-srv/api/partner/v0/util/phones"), {
    number: phoneNumber
  }, {}, true, false);
};
var refreshToken = exports.refreshToken = function refreshToken() {
  return _RestHelper.default.get("".concat(_RestHelper.default.getBaseUrl(_RestHelper.MWDomains.cscCustomer), "/cscn-customer-srv/api/partner/v0/token"));
};
function getPhonenIdFromPhoneObject(phoneNumberObj) {
  var _phoneNumberObj$_link, _phoneNumberObj$_link2, _phoneNumberObj$_link3;
  return phoneNumberObj === null || phoneNumberObj === void 0 ? void 0 : (_phoneNumberObj$_link = phoneNumberObj._links) === null || _phoneNumberObj$_link === void 0 ? void 0 : (_phoneNumberObj$_link2 = _phoneNumberObj$_link.self) === null || _phoneNumberObj$_link2 === void 0 ? void 0 : (_phoneNumberObj$_link3 = _phoneNumberObj$_link2.href) === null || _phoneNumberObj$_link3 === void 0 ? void 0 : _phoneNumberObj$_link3.split('/').pop();
}
function getMyData(contractId) {
  return _RestHelper.default.get("".concat(_RestHelper.default.getBaseUrl(_RestHelper.MWDomains.cscCustomer), "/cscn-customer-srv/api/partner/v0/mydata/").concat(contractId));
}
function getPersonalData(contractId) {
  return _RestHelper.default.get("".concat(_RestHelper.default.getBaseUrl(_RestHelper.MWDomains.cscCustomer), "/cscn-customer-srv/api/partner/v0/mydata/").concat(contractId));
}
function getBankDetails(iban) {
  return _RestHelper.default.post("".concat(_RestHelper.default.getBaseUrl(_RestHelper.MWDomains.cscCustomer), "/cscn-customer-srv/api/partner/v0/util/iban"), iban);
}
function addBankingData(bankDetailsObj, contractId) {
  return _RestHelper.default.post("".concat(_RestHelper.default.getBaseUrl(_RestHelper.MWDomains.cscCustomer), "/cscn-customer-srv/api/partner/v0/mydata/").concat(contractId, "/bankaccounts"), bankDetailsObj);
}
function saveMyData(emailData, contractId) {
  return _RestHelper.default.put("".concat(_RestHelper.default.getBaseUrl(_RestHelper.MWDomains.cscCustomer), "/cscn-customer-srv/api/partner/v0/mydata/").concat(contractId), emailData);
}
function getBusinessPartner() {
  return _RestHelper.default.get("".concat(_RestHelper.default.getBaseUrl(_RestHelper.MWDomains.cscCustomer), "/cscn-customer-srv/api/partner/v0/businesspartners"));
}
function addPhoneNumber(phoneNumberObj, contractId) {
  return _RestHelper.default.post("".concat(_RestHelper.default.getBaseUrl(_RestHelper.MWDomains.cscCustomer), "/cscn-customer-srv/api/partner/v0/mydata/").concat(contractId, "/phonenumbers"), phoneNumberObj);
}
function editPhoneNumbers(phoneNumberObj, contractId) {
  return _RestHelper.default.put("".concat(_RestHelper.default.getBaseUrl(_RestHelper.MWDomains.cscCustomer), "/cscn-customer-srv/api/partner/v0/mydata/").concat(contractId, "/phonenumbers/").concat(phoneNumberObj.order), phoneNumberObj);
}
function getPhoneNumbers(contractId) {
  return _RestHelper.default.get("".concat(_RestHelper.default.getBaseUrl(_RestHelper.MWDomains.cscCustomer), "/cscn-customer-srv/api/partner/v0/mydata/").concat(contractId, "/phonenumbers")).then(function (response) {
    return {
      data: {
        content: response.data.content.map(function (item) {
          var splitLink = item._links.self.href.split('/');
          return {
            phone: item.phone,
            order: splitLink[splitLink.length - 1],
            default: item.default
          };
        })
      }
    };
  }).catch(function (error) {
    throw error;
  });
}
function deletePhoneNumber(phoneNumberObject, contractId) {
  return _RestHelper.default.delete("".concat(_RestHelper.default.getBaseUrl(_RestHelper.MWDomains.cscCustomer), "/cscn-customer-srv/api/partner/v0/mydata/").concat(contractId, "/phonenumbers/").concat(phoneNumberObject.order));
}
function getTaxVatNumbers(contractId) {
  return _RestHelper.default.get("".concat(_RestHelper.default.getBaseUrl(_RestHelper.MWDomains.cscCustomer), "/cscn-customer-srv/api/partner/v0/mydata/").concat(contractId, "/taxnumbers"));
}
var saveTaxVatNumber = exports.saveTaxVatNumber = function saveTaxVatNumber(contractId, data) {
  return _RestHelper.default.patch("".concat(_RestHelper.default.getBaseUrl(_RestHelper.MWDomains.cscCustomer), "/cscn-customer-srv/api/partner/v0/mydata/").concat(contractId, "/taxnumbers"), data).then(function (response) {
    _CacheHandler.default.saveCache({
      taxVatData: _objectSpread({}, response)
    });
    return response;
  }).catch(function (error) {
    throw error.response;
  });
};
var _default = exports.default = {
  saveMyData: saveMyData,
  addPhoneNumber: addPhoneNumber,
  getPhoneNumbers: getPhoneNumbers,
  editPhoneNumbers: editPhoneNumbers,
  deletePhoneNumber: deletePhoneNumber,
  getTaxVatNumbers: getTaxVatNumbers,
  saveTaxVatNumber: saveTaxVatNumber,
  getBusinessPartner: getBusinessPartner,
  getPhonenIdFromPhoneObject: getPhonenIdFromPhoneObject,
  getMyData: getMyData,
  getPersonalData: getPersonalData,
  refreshToken: refreshToken,
  validatePhoneNumber: validatePhoneNumber,
  getBankDetails: getBankDetails,
  addBankingData: addBankingData
};